<template>
  <div class="details">
    <div class="item">
      <p><span>发布人</span>{{ resumeDetails.crate_username }}</p>
      <p><span>发布日期</span>{{ resumeDetails.create_time }}</p>
    </div>

    <div class="item">
      <p><span>应聘者</span> {{ resumeDetails.applicant_name }}</p>
      <p><span>年龄</span> {{ resumeDetails.age }}</p>
    </div>
    <div class="item">
      <p><span>应聘部门</span> {{ resumeDetails.applicant_section }}</p>
      <p><span>应聘岗位</span> {{ resumeDetails.position_applied }}</p>
    </div>
    <div class="item">
      <p><span>毕业院校</span> {{ resumeDetails.graduate_school }}</p>
      <p><span>专业</span> {{ resumeDetails.major }}</p>
    </div>
    <div class="item">
      <p><span>最高学历</span> {{ resumeDetails.highest_education }}</p>
    </div>

    <div class="item mt20">
      <p><span>任务说明</span> 按八大维度对简历进行评估并填写监理筛选评估表</p>
    </div>
    <div class="item mt20">
      <p>
        <span>附件</span
        >
        <download-url :url="resumeDetails.accessory_url"></download-url>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    resumeDetails: {},
  },
};
</script>

<style lang="scss" scoped>
.details {
  padding: 15px;
  font-size: 14px;
  .item {
    display: flex;
    margin-bottom: 12px;
    p {
      flex: 1;
      color: #333;
      display: flex;

      span {
        color: #a1a1a1;
        width: 70px;
        text-align: right;
        margin-right: 8px;
      }
      a {
        color: #3399ff;
        width: 250px;
        word-wrap: break-word;
      }
    }
  }
}
</style>
